import React, { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import DataNotFound from "../../../../../component/ui/loader/data-not-found";
import {
  CalendarIcon,
  ChevronLeft,
  ChevronRight,
  Eye,
  FileDown,
  IdCard,
  ListIcon,
  Pencil,
  Plus,
  PlusIcon,
  Receipt,
} from "lucide-react";
import { useApiCall } from "../../../../../component/custom-hooks/api-call";
// import moment from 'moment';
// import WeekRangePicker from '../../../../../component/ui/calendar/custom';
import DynamicFilter from "../../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../../component/icons/filter-funnel-01";
// import ChangeHolidayStatus from '../../../../../component/popup/change-holiday-status';
import { Alert, Skeleton, Snackbar } from "@mui/material";
import moment from "moment";
import CustomizeTabsPopup from "../../../../../component/table/customize-table";
import LayoutTopIcon from "../../../../../component/icons/layout-top";
import XCloseIcon from "../../../../../component/icons/x-close";
import { Link } from "react-router";
import * as XLSX from "xlsx";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../../../component/table/table-layout";
import NewEyeIcon from "../../../../../component/icons/action-eye-icon";
import NewCardIcon from "../../../../../component/icons/action-card-icon";
import StatusChip from "../../../../../component/ui/chip/status";
import Tooltip from "../../../../../component/ui/tooltip";
import InvoiceQuickView from "../../../../../component/invoice/InvoiceQuickView";
import { CustomDropdown } from "../../../../../component/ui/dropdown/CustomDropdown";
import { CustomDropdownButton } from "../../../../../component/ui/dropdown/CustomDropdownButton";
import DotsVerticalIcon from "../../../../../component/icons/dots-vertical";
import { CustomDropdownMenu } from "../../../../../component/ui/dropdown/CustomDropdownMenu";
import { CustomDropdownMenuDivider } from "../../../../../component/ui/dropdown/CustomDropdownMenuDivider";
import { CustomDropdownMenuList } from "../../../../../component/ui/dropdown/CustomDropdownMenuList";
import ChevronDownIcon from "../../../../../component/icons/chevron-down";
import FileCode1Icon from "../../../../../component/icons/file-code-1";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import ProjectQuickView from "../../../../projects/project/popup";
import NewEditIcon from "../../../../../component/icons/action-edit-icon";
import InnerLoader from "../../../../../component/ui/loader/inner-loader";



const RefundList = ({ data = {}, isLoading = true }) => {
  const masterCheckboxRef = useRef();
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [holidays, setHolidays] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [changeModal, setChangeModal] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [currentStatus, setCurrentStatus] = useState("");
  const [brands, setBrands] = useState([]);
  const [products, setProducts] = useState([]);
  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [tableHeader, setTableHeader] = useState([]);
  const [empPopup, setEmpPopup] = useState(false);
  const [empData, setEmpData] = useState({});
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [exportTo, setExportTo] = useState(false);

  const [invoicePopup, setInvoicePopup] = useState(false);
  const [invoiceData, setInvoiceData] = useState(null);

  const [pageCount, setPageCount] = useState(1);
  const [pageItemsCount, setPageItemsCount] = useState(10);
  const [showAddTaskModal, setShowAddTaskModal] = useState(false);

  const [editTaskData, setEditTaskData] = useState({});
  const [users, setUsers] = useState([]);
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    setApiData(data);
  }, [data]);

  const toggleSelectAll = (checked) => {
    if (checked) {
      setSelectedProjects(apiData.map((d) => d?.sub_task_key));
    } else {
      setSelectedProjects([]);
    }
  };

  // ✅ Toggle Single Row
  const toggleSelectRow = (projectKey) => {
    setSelectedProjects((prev) =>
      prev.includes(projectKey)
        ? prev.filter((id) => id !== projectKey)
        : [...prev, projectKey]
    );
  };

  const handleExport = async (type, localData = null) => {
    try {
      // ✅ If user already selected rows (local data)
      if (localData && localData.length > 0) {
        exportData(localData, type);
        return;
      }

      const filters = filterReturn || [];
      const page = 1;
      const page_quantity = "all";

      const data = { page, page_quantity, filters };

      Swal.fire({
        title: "Exporting Sub Task...",
        text: "Please wait while we export your data.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // 🧩 Convert filters array → object
      const filtersObj = data.filters.reduce((acc, f) => {
        if (f.value !== "" && f.value !== null && f.value !== undefined) {
          acc[f.field] = f.value;
        }
        return acc;
      }, {});

      const transformed = {
        page_quantity: String(data.page_quantity || ""),
        page: String(data.page || "1"),
        ...filtersObj,
      };

      const apiData = JSON.stringify(transformed);

      const res = await apiCall({
        url: `subtasks/subtasks-list`,
        method: "get",
        data: apiData,
      });

      const projectsData = res?.data || res?.projects || [];
      if (!projectsData?.length) {
        Swal.fire({
          title: "Warning!",
          text: "No sub task data available to export.",
          icon: "warning",
          confirmButtonText: "OK",
          buttonsStyling: false,
          customClass: { confirmButton: Style.customSwalBtn },
        });
        return;
      }

      exportData(projectsData, type);
    } catch (error) {
      console.error("Export Error:", error);
      Swal.fire({
        title: "Error!",
        text: "Something went wrong while exporting.",
        icon: "error",
        confirmButtonText: "OK",
        buttonsStyling: false,
        customClass: { confirmButton: Style.customSwalBtn },
      });
    }
  };

  const exportData = (data, type) => {
    const visibleColumns = tableHeader
      ?.filter((col) => col.is_visible === 1 && col.show == 1)
      ?.map((col) => ({ key: col.key, label: col.value }));

    const formattedData = data.map((row) => {
      const obj = {};

      obj["Sub Task"] = row?.sub_task_name || "-";
      // obj["Customer Email"] = row?.customer_details?.email || "-";
      // obj["Customer Phone"] = row?.customer_details?.phone || "-";

      visibleColumns.forEach(({ key, label }) => {
        if (
          [
            "project_name",
            "customer_details",
            "customer_name",
            "customer_email",
            "customer_phone",
          ].includes(key)
        )
          return; // skip duplicates

        if (key === "sub_task_description") {
          obj[label || "Task Description"] = row?.sub_task_description || "-";
        } else if (key === "deadline") {
          obj[label || "Deadline"] = row?.deadline || "-";
        } else if (key === "sub_task_status") {
          obj[label || "Status"] = row?.sub_task_status || "-";
        } else if (key === "priority") {
          obj[label || "priority"] = row?.priority || "-";
        } else if (key === "source") {
          obj[label || "source"] = row?.source || "-";
        } else if (key === "timestamp") {
          obj[label || "Timestamp"] = row?.timestamp || "-";
        } else if (["created_at", "signupdate"].includes(key)) {
          obj[label || key] = row[key]
            ? dayjs(row[key]).format("DD-MMM-YYYY")
            : "-";
        } else {
          obj[label || key] =
            typeof row[key] === "object" && row[key] !== null
              ? JSON.stringify(row[key])
              : row[key] ?? "-";
        }
      });

      return obj;
    });

    // 📁 File name
    const fileName = `subTask_${new Date()
      .toISOString()
      .slice(0, 19)
      .replace(/[:T]/g, "-")}`;

    // 💾 Export logic
    if (type === "csv") {
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const csvContent = XLSX.utils.sheet_to_csv(worksheet);
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${fileName}.csv`;
      link.click();
    } else if (type === "excel") {
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sub Tasks");
      XLSX.writeFile(workbook, `${fileName}.xlsx`);
    }

    Swal.fire({
      title: "Success!",
      text: "Sub Task data exported successfully.",
      icon: "success",
      confirmButtonText: "OK",
      buttonsStyling: false,
      customClass: { confirmButton: Style.customSwalBtn },
    });
  };

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const apiCall = useApiCall();

  const handleToggleAll = () => {
    const allIds = apiData.map(
      (ele) => `${ele.employee_id}---${ele.holiday_id}`
    );
    const isAllChecked = selectedIds?.length === allIds?.length;
    setSelectedIds(isAllChecked ? [] : allIds);
  };

  const handleToggleOne = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((v) => v !== id) : [...prev, id]
    );
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    // getData({});
    setShowAddTaskModal(false);
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const onStatusChange = (value) => {
    setCurrentStatus(value);
    setChangeModal(true);
  };

  const filterModalData = [
    {
      name: "sub_task_name",
      label: "Name",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: apiData,
      dropdownKey: "sub_task_name",
      dropdownVal: "sub_task_name",
    },
    {
      name: "sub_task_status",
      label: "Sub Task Status",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [
        { label: "Pending", value: "pending" },
        { label: "Completed", value: "completed" },
      ],
      dropdownKey: "label",
      dropdownVal: "value",
    },
    {
      name: "priority",
      label: "Priority",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [
        { label: "High", value: "High" },
        { label: "Medium", value: "Medium" },
        { label: "Low", value: "Low" },
      ],
      dropdownKey: "label",
      dropdownVal: "value",
    },
    {
      name: "deadline",
      label: "Deadline",
      options: ["is", "between"],
      selectedOpt: "is",
      value: "",
      type: "date",
      dropdownKey: "label",
      dropdownVal: "value",
      betweenType: "date",
    },

    {
      name: "username",
      label: "Username",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "text",
      // dropdown: products,
      // dropdownKey: "products",
      // dropdownVal: "products",
    },
  ];

  const editTask = (eachList) => {
    setEditTaskData(eachList);
    setShowAddTaskModal(true);
  };

  const tableRef = useRef(null);

  const [expandedRows, setExpandedRows] = useState([]);
  const [subTaskModal, setSubTaskModal] = useState(false);
  const [subTaskData, setSubTaskData] = useState({});
  const [subTaskPopup, setSubTaskPopup] = useState(false);
  const [subTaskPopupData, setSubTaskPopUpData] = useState({});

  const toggleRow = (id) => {
    setExpandedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  const editSubTask = (eachList) => {
    setSubTaskData(eachList);
    setSubTaskModal(true);
  };

  // console.log("apiData", apiData)

  return (
    <>
      <div className={`${Style.mainBody} `}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>

              {/* HEADER */}
              <div className={Style.empDirectory_header}>
                <div className="flex justify-between items-center w-full">
                  <div className="text-xl font-bold pl-3 flex items-center gap-1 leading-10 ">
                    QA Status Reports
                  </div>
                  <div className="text-[#A4A7AE] transition-all duration-300 hover:text-gray-500 cursor-pointer">
                    <DotsVerticalIcon />
                  </div>
                </div>
              </div>

              {/* BODY */}
              <div className={Style.empDirectory_body}>
                {!isLoading ? (
                  <InnerLoader />
                ) : !apiData?.length ? (
                  <DataNotFound title={"Refund"} />
                ) : (
                  <>
                    <div className="w-full h-full !overflow-auto">
                      <Table ref={tableRef}>
                        <TableHead>
                          <TableRow>
                            <TableCell header sticky>
                              <div className="flex gap-2 items-center">
                                <TableHeaderWrap>
                                  <span className="pl-[50px]">QA Status</span>
                                </TableHeaderWrap>
                              </div>
                            </TableCell>
                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Count</span>
                              </TableHeaderWrap>
                            </TableCell>
                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Percentage of Count</span>
                              </TableHeaderWrap>
                            </TableCell>
                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Amount Lost</span>
                              </TableHeaderWrap>
                            </TableCell>
                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Percentage of Amount Lost</span>
                              </TableHeaderWrap>
                            </TableCell>
                            <TableCell header>
                              <TableHeaderWrap>
                                <span>Key</span>
                              </TableHeaderWrap>
                            </TableCell>
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {apiData?.map((eachList, index) => {
                            return (
                              <>
                                <TableRow key={`${index}`}>
                                  <TableCell sticky>
                                    <div
                                      className={`${Style.tableActionArea} !gap-4`}
                                    >
                                      <div className="flex gap-2 items-center">
                                        <div className="flex items-center gap-3">
                                          <div className="font-medium leading-5">
                                            {eachList?.qa_status}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </TableCell>

                                  <TableCell>
                                    {eachList?.count ?? "-"}
                                  </TableCell>
                                  <TableCell>
                                    {eachList?.percentage_of_count ?? "-"}
                                  </TableCell>
                                  <TableCell>
                                    {eachList?.amount_lost ?? "-"}
                                  </TableCell>

                                  <TableCell>
                                    {eachList?.percentage_of_amount_lost ?? "-"}
                                  </TableCell>
                                  <TableCell>{eachList?.key ?? "-"}</TableCell>
                                </TableRow>
                              </>
                            );
                          })}
                        </TableBody>
                      </Table>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeader}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeader(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeader(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl={`subtasks/subtasks-list`}
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default RefundList;
